import { useEffect } from 'react';

import { useContextNavigate } from '../../shared/hooks/use-context-navigate';

export function useResponseHandler(transactionId?: string) {
    const navigate = useContextNavigate();
    useEffect(() => {
        let messenger: BroadcastChannel | null = null;
        const handler = (message: MessageEvent) => {
            const data = message.data;
            if (data.source === 'redirect' && data.transactionId === transactionId) {
                navigate(`/cashier/${data.method}/complete/${data.transactionId}`);

                // Inform the popup we've received the message.
                messenger?.postMessage({
                    source: 'app',
                    transactionId: transactionId,
                });
            }
        };

        if (window.BroadcastChannel) {
            messenger = new BroadcastChannel('cashier');

            messenger.addEventListener('message', handler);
        }

        return () => {
            messenger?.removeEventListener('message', handler);
            messenger?.close();
        };
    }, [transactionId, navigate]);
}
